import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { Button, buttonTheme } from 'storybook-ui'

import { Container } from 'components/Container'

import { useDefaultSubscription } from 'modules/purchase/hooks'
import { useGetSubscriptionsList } from 'modules/purchase/hooks/useGetSubscriptionsList'

import beforeAfterImage from 'assets/images/before-after-cancel-question.png'

import { goTo } from 'browser-history'
import { PageId } from 'page-constants'

import { StyledCancelOfferQuestion as S } from './CancelOfferQuestion.styles'

export const CancelOfferQuestion: React.FC = () => {
  const { t } = useTranslation()
  const { search } = useLocation()

  useGetSubscriptionsList()
  useDefaultSubscription()

  const handleContinue = () => {
    goTo({ pathname: PageId.SPECIAL_PURCHASE_CANCEL_OFFER, search })
  }

  return (
    <div>
      <Container>
        <S.Title>{t('cancelOfferQuestion.title')}</S.Title>
        <S.Subtitle>
          <Trans
            i18nKey="cancelOfferQuestion.subtitle"
            components={{ strong: <strong />, b: <b /> }}
          />
        </S.Subtitle>
        <S.ImageContainer>
          <img src={beforeAfterImage} alt="" />
          <span>{t('cancelOfferQuestion.beforeText')}</span>
          <span>{t('cancelOfferQuestion.afterText')}</span>
        </S.ImageContainer>
        <S.ImageCaption>{t('cancelOfferQuestion.imageCaption')}</S.ImageCaption>
        <S.ExclusiveOffer>
          <Trans
            i18nKey="cancelOfferQuestion.exclusiveOffer"
            components={[<strong />]}
          />
        </S.ExclusiveOffer>
        <Button
          theme={buttonTheme.LUVLY}
          borderRadius="12px"
          height="48px"
          lineHeight="48px"
          onClick={handleContinue}
        >
          {t('actions.gotIt4')}
        </Button>
      </Container>
    </div>
  )
}
